import type { TProductCard } from '@chemist4u/newt-components';
import type { ProductCardVM, VariantPrice } from 'types/view-models';

function formatPrice(price: VariantPrice): string {
  if (price.has_multiple_prices) {
    return `From ${price.calculated_price}`;
  }
  return price.calculated_price;
}

export function toProductCardProps(card: ProductCardVM): TProductCard {
  const price = card.price;
  const thumbnailUrl = card.thumbnail || card.images?.[0]?.url || '';

  return {
    productName: card.title,
    image: {
      id: card.id,
      url: thumbnailUrl,
      src: thumbnailUrl,
      alt: card.title,
    },
    href: `/${card.handle}`,
    price: price ? formatPrice(price) : undefined,
    compareAtPrice:
      price?.price_type === 'sale' ? price.original_price : undefined,
  };
}
